import script from "./TheLayoutHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TheLayoutHeader.vue?vue&type=script&setup=true&lang=js"

import "./TheLayoutHeader.vue?vue&type=style&index=0&id=0887087c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0887087c"]])

export default __exports__